import React, { useEffect, useState } from "react";

/**
 * Rotating word effect for the hero.
 * Absolute-positioned words cycle with a vertical flip + skew.
 * A hidden "ghost" sizes the container to the longest word so layout is stable.
 */
export default function RotatingWord({ words = [], interval = 2400, className = "" }) {
  const [idx, setIdx] = useState(0);

  useEffect(() => {
    const t = setInterval(() => setIdx((v) => (v + 1) % words.length), interval);
    return () => clearInterval(t);
  }, [words.length, interval]);

  const longest = words.reduce((a, b) => (a.length >= b.length ? a : b), "");

  return (
    <span className={`rotating-word ${className}`}>
      <span className="ghost">{longest}</span>
      {words.map((w, i) => (
        <span key={w} className={`word ${i === idx ? "active" : ""}`}>{w}</span>
      ))}
    </span>
  );
}
